import React from 'react'
import { useDispatch } from 'react-redux'
import i18n from 'i18next'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import IllustrationCard from '~/Common-Objects/UI/Cards/IllustrationCard'
import Row from '~/Common-Objects/Grids/Row/Row'
import UpsellModal from '~/Common-Objects/UpsellModal'
import RegularFormImg from '~/assets/images/illustrations/regular-form.svg'
import GatedContentImg from '~/assets/images/illustrations/gated-content.svg'
import { NORMAL_FORM, GATED_CONTENT } from '../index'
import { alterFullpage } from '~/data/actions/siteActions'
import useTierAllowed from '~/Common-Objects/hooks/useTierAllowed'

export default function SelectFormType({ onSelect }) {
    const dispatch = useDispatch()
    const { requiredTier, tierAllowed } = useTierAllowed('gatedContent')
    const columnProps = {
        xs: 12,
        sm: 6,
        md: 4,
        lg: 3,
        className: 'mar-b24'
    }

    const select = (type) => {
        if (type == GATED_CONTENT && !tierAllowed) {
            const modal = (
                <UpsellModal
                    feature={'gatedContent'}
                    requiredTier={requiredTier?.name}
                    inline={true}
                    onUpgrade={async () => {
                        dispatch(alterFullpage(null))
                    }}
                />
            )
            dispatch(alterFullpage(modal))
        } else {
            onSelect(type)
        }
    }

    return (
        <>
            <div className='center-xs mar-b60'>
                <h1 className='h2 mar-b10'>{i18n.t('campaigns:overview.createANewForm')}</h1>
                <p className='text-md text-grey'>{i18n.t('form:add.type.header')}</p>
            </div>

            <Row className='center-xs'>
                <Column {...columnProps}>
                    <IllustrationCard
                        className='illustration-card--purple'
                        img={<img src={RegularFormImg} alt='' />}
                        headingTag='h2'
                        heading={i18n.t('form:add.type.regular')}
                        cta={
                            <Button className='button-primary' onClick={() => select(NORMAL_FORM)}>
                                {i18n.t('form:add.type.regularSelect')}
                            </Button>
                        }
                    >
                        <p>{i18n.t('form:add.type.regularText')}</p>
                    </IllustrationCard>
                </Column>

                <Column {...columnProps}>
                    <IllustrationCard
                        className='illustration-card--green'
                        img={<img src={GatedContentImg} alt='' />}
                        headingTag='h2'
                        heading={i18n.t('form:add.type.gated')}
                        cta={
                            <Button
                                className={tierAllowed ? 'button-primary' : 'button-grey'}
                                onClick={() => select(GATED_CONTENT)}
                            >
                                {tierAllowed
                                    ? i18n.t('form:add.type.gatedSelect')
                                    : i18n.t('form:add.type.gatedDisabled')}
                            </Button>
                        }
                    >
                        <p>{i18n.t('form:add.type.gatedText')}</p>
                    </IllustrationCard>
                </Column>
            </Row>
        </>
    )
}
